import React, { useEffect, useState } from "react";
import { apiClient } from "../../config";

const UploadVideo = () => {
  const [courses, setCourses] = useState([]);
  const [modules, setModules] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedModule, setSelectedModule] = useState("");
  const [videoTitle, setVideoTitle] = useState("");
  const [videoType, setVideoType] = useState("");
  const [videoFile, setVideoFile] = useState(null);
  const [youtubeUrl, setYoutubeUrl] = useState("");
  const [transcript, setTranscript] = useState("");
  const [generateQuestions, setGenerateQuestions] = useState(false);
  const [videoList, setVideoList] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const [loading, setLoading] = useState(false);

  // Fetch courses initially
  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const res = await apiClient.get("/api/course/courses");
      const data = res.data;
      setCourses(Array.isArray(data) ? data : data.data || []);
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  const fetchModules = async (courseId) => {
    try {
      const res = await apiClient.get(`/api/course/modules/${courseId}`);
      setModules(res.data || []);
    } catch (error) {
      console.error("Error fetching modules:", error);
    }
  };

  const handleCourseChange = (e) => {
    const courseId = e.target.value;
    setSelectedCourse(courseId);
    setSelectedModule("");
    setModules([]);
    if (courseId) {
      fetchModules(courseId);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!videoTitle || !videoType || !selectedCourse || !selectedModule) {
      alert("Please fill out all required fields.");
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("title", videoTitle);
      formData.append("type", videoType);
      formData.append("courseId", selectedCourse);
      formData.append("moduleId", selectedModule);
      formData.append("transcript", transcript);
      formData.append("userId", localStorage.getItem("userId") || "demo-user");
      formData.append("generateAssessment", generateQuestions);

      if (videoType === "youtube") {
        if (!youtubeUrl) {
          setLoading(false);
          return alert("Please enter a YouTube embed URL.");
        }
        formData.append("videoUrl", youtubeUrl);
      } else if (videoType === "upload") {
        if (!videoFile) {
          setLoading(false);
          return alert("Please select a video file.");
        }
        formData.append("video", videoFile);
      }

      const response = await apiClient.post("/api/course/videos/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const result = response.data;
      if (!result.success) throw new Error(result.message || "Upload failed");

      setVideoList([...videoList, result.data]);
      setVideoTitle("");
      setVideoType("");
      setVideoFile(null);
      setYoutubeUrl("");
      setTranscript("");
      setGenerateQuestions(false);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    } catch (err) {
      console.error("Upload Error:", err);
      alert(err.response?.data?.message || err.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const handleModuleChange = (e) => {
    const id = e.target.value;
    setSelectedModule(id);
    if (id) {
      fetchVideosByModule(id);
    }
  };

  const fetchVideosByModule = async (moduleId) => {
    try {
      const res = await apiClient.get(`/api/course/videos/${moduleId}`);
      const data = res.data;
      console.log("Fetched videos:", data);

      const videos = Array.isArray(data)
        ? data
        : data.data || data.videos || [];
      setVideoList(videos);
    } catch (error) {
      console.error("Error fetching videos:", error);
      setVideoList([]);
    }
  };

  return (
    <div>
        <div className="row mb-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-transparent border-bottom py-3">
                <h5 className="mb-0 fw-semibold">Upload Video</h5>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-semibold">
                        Select Course *
                      </label>
                      <select
                        className="form-select"
                        value={selectedCourse}
                        onChange={handleCourseChange}
                      >
                        <option value="">-- Select Course --</option>
                        {courses?.map((course) => (
                          <option key={course._id} value={course._id}>
                            {course.title}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-semibold">
                        Course Module *
                      </label>
                      <select
                        className="form-select"
                        value={selectedModule}
                        onChange={handleModuleChange}
                      >
                        <option value="">-- Select Module --</option>
                        {modules?.map((mod) => (
                          <option key={mod._id} value={mod._id}>
                            {mod.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-semibold">
                        Video Title *
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter video title"
                        value={videoTitle}
                        onChange={(e) => setVideoTitle(e.target.value)}
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-semibold">
                        Video Type *
                      </label>
                      <select
                        className="form-select"
                        value={videoType}
                        onChange={(e) => setVideoType(e.target.value)}
                      >
                        <option value="">-- Select Type --</option>
                        <option value="youtube">YouTube</option>
                        <option value="upload">EIM Upload (Vimeo)</option>
                      </select>
                    </div>

                    {videoType === "upload" && (
                      <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">
                          Video File *
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          onChange={(e) => setVideoFile(e.target.files[0])}
                        />
                        {videoFile && (
                          <small className="text-info mt-1 d-block">
                            Selected: {videoFile.name}
                          </small>
                        )}
                      </div>
                    )}

                    {videoType === "youtube" && (
                      <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">
                          YouTube Embed URL *
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="e.g. https://www.youtube.com/embed/..."
                          value={youtubeUrl}
                          onChange={(e) => setYoutubeUrl(e.target.value)}
                        />
                      </div>
                    )}

                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-semibold">
                        Transcript (Optional)
                      </label>
                      <textarea
                        className="form-control"
                        placeholder="Paste transcript or video descriptions"
                        value={transcript}
                        rows={3}
                        onChange={(e) => setTranscript(e.target.value)}
                      />
                    </div>

                    <div className="col-12 mb-3">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="generateQuestionsCheck"
                          checked={generateQuestions}
                          onChange={() =>
                            setGenerateQuestions(!generateQuestions)
                          }
                        />
                        <label className="form-check-label fw-semibold" htmlFor="generateQuestionsCheck">
                          Generate 25 assessment questions
                        </label>
                      </div>
                    </div>

                    <div className="col-12">
                      <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                        {loading ? 'Uploading...' : 'Upload Video'}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Video Table */}
        <div className="row">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-transparent border-bottom py-3">
                <h5 className="mb-0 fw-semibold">Module Videos</h5>
              </div>
              <div className="card-body p-0 table-responsive">
                <table className="table table-hover table-striped align-middle mb-0">
                  <thead>
                    <tr>
                      <th className="ps-4" style={{ width: "60px" }}>#</th>
                      <th>Title</th>
                      <th>Type</th>
                      <th>Transcript</th>
                      <th>Assessment</th>
                      <th className="pe-4 text-end">Video</th>
                    </tr>
                  </thead>
                  <tbody>
                    {videoList?.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="text-center py-4 text-muted">
                          No videos uploaded yet for this module.
                        </td>
                      </tr>
                    ) : (
                      videoList?.map((video, index) => (
                        <tr key={index}>
                          <td className="ps-4 fw-semibold">{index + 1}</td>
                          <td className="fw-semibold">{video.title}</td>
                          <td>{video.type}</td>
                          <td>
                            {video.transcript ? (
                              <span className="badge bg-info">Available</span>
                            ) : (
                              <span className="badge bg-secondary text-dark">None</span>
                            )}
                          </td>
                          <td>
                            {video.generateAssessment ? (
                              <span className="badge bg-success">
                                ✔ Generated
                              </span>
                            ) : (
                              <span className="badge bg-warning text-dark">
                                Pending
                              </span>
                            )}
                          </td>
                          <td className="pe-4 text-end">
                            {video.type === "youtube" ? (
                              <span className="text-primary fw-semibold">
                                YouTube ▶
                              </span>
                            ) : video.vimeoId ? (
                              <a
                                href={`https://player.vimeo.com/video/${video.vimeoId}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-primary fw-semibold text-decoration-none"
                              >
                                Vimeo ▶
                              </a>
                            ) : (
                              <span className="text-secondary fw-semibold">
                                Uploaded 📁
                              </span>
                            )}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

      {/* Toast Notification */}
      {showToast && (
        <div
          className="toast align-items-center text-white bg-success border-0 show position-fixed bottom-0 end-0 m-4"
          role="alert"
          style={{ zIndex: 1055 }}
        >
          <div className="d-flex">
            <div className="toast-body">✅ Video uploaded successfully!</div>
            <button
              type="button"
              className="btn-close btn-close-white me-2 m-auto"
              onClick={() => setShowToast(false)}
            ></button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadVideo;
